export const CONTINUE = "Continue";
export const CHOOSE_TIMES = "Choose Times";
